import { AbilityBuilder } from '@casl/ability';
import { SurfaceNodeActions } from 'services/authorization/actions';

export default function defineRestrictedViewerPermissions(
  { can }: AbilityBuilder<any>,
  user: string,
) {
  can(SurfaceNodeActions.read, 'SurfaceNode');
}
